module.exports = __webpack_public_path__ + "img/aziende-careers.a17289a7.png";